import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

function HotelsGrid() {
  const { sub_brand_name } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [hotels, setHotels] = useState([]);
    const [showModal, setShowModal] = useState(false);
  

  // Missing states — FIXED
  const [submitting, setSubmitting] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");

  const [bookingData, setBookingData] = useState({
    package_code: "",
    first_guest_name: "",
    total_persons: "",
    check_in_date: "",
    check_out_date: "",
    extra_bed: "",
    child_without_bed: "",
    meal_plan: "",
    mobile_no: "",
    additional_info: "",
  });

  const IMAGE_BASE_URL = "https://travchap.com/admin/";

  useEffect(() => {
    const fetchHotels = async () => {
      try {
        const response = await fetch(
          `https://travchap.com/admin/api/hotels/sub_brand/${sub_brand_name}`
        );
        if (!response.ok) throw new Error("Failed to fetch hotels");

        const data = await response.json();
        setHotels(data.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchHotels();
  }, [sub_brand_name]);

  const handleBookingSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setResponseMsg("");

    try {
      const formData = new FormData();
      Object.entries(bookingData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const res = await fetch("https://travchap.com/admin/api/booking", {
        method: "POST",
        body: formData,
      });

      const result = await res.json();

      if (res.ok) {
        setResponseMsg("✅ Booking submitted successfully!");
        setBookingData({
          package_code: "",
          first_guest_name: "",
          total_persons: "",
          check_in_date: "",
          check_out_date: "",
          extra_bed: "",
          child_without_bed: "",
          meal_plan: "",
          mobile_no: "",
          additional_info: "",
        });
      } else {
        setResponseMsg(result.message || "❌ Booking failed. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setResponseMsg("⚠️ Something went wrong. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

    const handleBookingChange = (e) => {
    const { name, value } = e.target;
    setBookingData((prev) => ({ ...prev, [name]: value }));
  };

  if (loading) return <p>Loading hotels...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="w-full px-4 py-10">
      {/* HERO BANNER */}
      {hotels.length > 0 && (
        <div
          className="w-full h-64 sm:h-80 md:h-96 rounded-xl mb-10 bg-cover bg-center flex items-end p-6 text-white"
          style={{
            backgroundImage: `url(${IMAGE_BASE_URL}${hotels[0]?.hotel_image})`,
          }}
        >
          <div className="bg-black/40 px-4 py-2 rounded-lg backdrop-blur-sm">
            <h1 className="text-2xl sm:text-3xl font-bold">
              {hotels[0]?.hotel_name || sub_brand_name}
            </h1>
            <p className="text-sm opacity-90">📍 {hotels[0]?.location_name}</p>
          </div>
        </div>
      )}

      <h2 className="text-center text-2xl font-bold mb-8">
        {sub_brand_name} HOTEL DETAILS
      </h2>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {hotels.map((hotel) => (
          <div
            key={hotel.id}
            className="bg-white shadow-md rounded-xl overflow-hidden border"
          >
            <img
              src={
                hotel.hotel_image
                  ? `${IMAGE_BASE_URL}${hotel.hotel_image}`
                  : "https://via.placeholder.com/400x250?text=No+Image"
              }
              alt={hotel.hotel_name}
              className="w-full h-48 object-cover"
            />

            <div className="p-4">
              <h3 className="font-bold text-lg mb-1">{hotel.hotel_name}</h3>

              <p className="text-yellow-500 mb-1">
                {"★".repeat(Number(hotel.hotel_star))}
                {"☆".repeat(5 - Number(hotel.hotel_star))}
              </p>

              <p className="text-gray-600 text-sm mb-3">
                📍 {hotel.location_name}
              </p>

              <button className="w-full bg-teal-700 hover:bg-teal-800 text-white py-2 rounded-lg"
              onClick={() => setShowModal(true)}>
                BOOK NOW
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Response message (optional usage) */}
      {responseMsg && (
        <p className="text-center mt-6 font-semibold">{responseMsg}</p>
      )}

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start md:items-center z-50 overflow-y-auto">
          {/* Modal Container */}
          <div className="bg-[#083d56] text-white p-6 rounded-lg w-[95%] md:w-[90%] max-w-4xl relative mt-6 md:mt-20 overflow-y-auto max-h-[90vh]">

            {/* Close Button */}
            <button
              className="absolute top-2 right-2 text-white text-xl font-bold"
              onClick={() => setShowModal(false)}
            >
              ✖
            </button>

            {/* Title */}
            <h2 className="text-center text-lg md:text-2xl font-bold mb-6">
              Booking Now
            </h2>

            {/* Booking Form */}
            <form
              onSubmit={handleBookingSubmit}
              className="grid grid-cols-1 md:grid-cols-2 gap-4"
            >
              {/* Dynamic Input Fields */}
              {[
                { label: "Booking Code *", name: "package_code", type: "text" },
                { label: "First Guest Name *", name: "first_guest_name", type: "text" },
                { label: "Check In Date *", name: "check_in_date", type: "date" },
                { label: "Check Out Date *", name: "check_out_date", type: "date" },
                { label: "Mobile No *", name: "mobile_no", type: "number" },
              ].map((input) => (
                <div key={input.name} className="flex flex-col gap-1">
                  <label>{input.label}</label>
                  <input
                    type={input.type}
                    name={input.name}
                    value={bookingData[input.name]}
                    onChange={handleBookingChange}
                    className="p-2 rounded text-black"
                    required
                  />
                </div>
              ))}

              {/* Total Persons */}
              <div className="flex flex-col gap-1">
                <label>Total No. of Persons *</label>
                <select
                  name="total_persons"
                  value={bookingData.total_persons}
                  onChange={handleBookingChange}
                  className="p-2 rounded text-black"
                  required
                >
                  <option value="">Select</option>
                  {[0, 1, 2, 3, 4, 5, 6].map((n) => (
                    <option key={n}>{n}</option>
                  ))}
                </select>
              </div>

              {/* Extra Bed */}
              <div className="flex flex-col gap-1">
                <label>Extra Bed</label>
                <select
                  name="extra_bed"
                  value={bookingData.extra_bed}
                  onChange={handleBookingChange}
                  className="p-2 rounded text-black"
                >
                  <option value="">Select</option>
                  {[0, 1, 2, 3, 4, 5, 6].map((n) => (
                    <option key={n}>{n}</option>
                  ))}
                </select>
              </div>

              {/* Child Without Bed */}
              <div className="flex flex-col gap-1">
                <label>Child without Bed</label>
                <select
                  name="child_without_bed"
                  value={bookingData.child_without_bed}
                  onChange={handleBookingChange}
                  className="p-2 rounded text-black"
                >
                  <option value="">Select</option>
                  {[0, 1, 2, 3, 4, 5, 6].map((n) => (
                    <option key={n}>{n}</option>
                  ))}
                </select>
              </div>

              {/* Meal Plan */}
              <div className="flex flex-col gap-1">
                <label>Meal Plan *</label>
                <select
                  name="meal_plan"
                  value={bookingData.meal_plan}
                  onChange={handleBookingChange}
                  className="p-2 rounded text-black"
                  required
                >
                  <option value="">Select</option>
                  <option>Room with no meal</option>
                  <option>Breakfast</option>
                  <option>Breakfast and Dinner</option>
                  <option>Breakfast with Lunch & Dinner</option>
                </select>
              </div>

              {/* Additional Info */}
              <div className="flex flex-col gap-1 col-span-1 md:col-span-2">
                <label>Additional Information</label>
                <textarea
                  name="additional_info"
                  value={bookingData.additional_info}
                  onChange={handleBookingChange}
                  className="p-2 rounded text-black"
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={submitting}
                className="col-span-1 md:col-span-2 bg-[#246e73] py-2 rounded text-white font-bold hover:bg-white hover:text-[#246e73] transition"
              >
                {submitting ? "Submitting..." : "Submit"}
              </button>
            </form>

            {/* Response Message */}
            {responseMsg && (
              <p className="text-center mt-4 font-semibold text-yellow-300">
                {responseMsg}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default HotelsGrid;
